import React, { useState, useCallback } from 'react';
import axios from '../axios';

const EditNotificationSetting = (props) => {
  const [usersAdditionalInformation, setUsersAdditionalInformation] = useState(
    props.users_additional_information
  );

  const endpoint = `/api/users_additional_information/update/${usersAdditionalInformation.id}`;

  const onUpdateIsSendMyParticipateNoticeToFriends = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      const newUsersAdditionalInformation = {
        ...usersAdditionalInformation,
        is_send_my_participate_notice_to_friends: isChecked,
      };
      setUsersAdditionalInformation(newUsersAdditionalInformation);
      axios.post(endpoint, newUsersAdditionalInformation);
    },
    [usersAdditionalInformation]
  );

  const onUpdateIsReceiveFriendsParticipateNotice = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      const newUsersAdditionalInformation = {
        ...usersAdditionalInformation,
        is_receive_friends_participate_notice: isChecked,
      };
      setUsersAdditionalInformation(newUsersAdditionalInformation);
      axios.post(endpoint, newUsersAdditionalInformation);
    },
    [usersAdditionalInformation]
  );

  const onUpdateIsReceiveWatchedEventsNotice = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      const newUsersAdditionalInformation = {
        ...usersAdditionalInformation,
        is_receive_watched_events_notice: isChecked,
      };
      setUsersAdditionalInformation(newUsersAdditionalInformation);
      axios.post(endpoint, newUsersAdditionalInformation);
    },
    [usersAdditionalInformation]
  );

  const onUpdateIsReceiveNewTalkroomNotice = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      const newUsersAdditionalInformation = {
        ...usersAdditionalInformation,
        is_receive_new_talkroom_notice: isChecked,
      };
      setUsersAdditionalInformation(newUsersAdditionalInformation);
      axios.post(endpoint, newUsersAdditionalInformation);
    },
    [usersAdditionalInformation]
  );

  return (
    <div className="ns-2026__groups">
      {/* 自分の参加を外に出すかどうか。受け取る通知とは向きが逆なので分けている */}
      <section className="ns-2026__group">
        <h2 className="ns-2026__group-title">友だちへの通知</h2>
        <div className="ns-2026__list">
          <div className="ns-2026__row">
            <span className="ns-2026__tag">VIPメンバー限定</span>
            <div className="ns-2026__row-main">
              <p className="ns-2026__row-title">自分が参加するイベントを友だちに通知</p>
              <div className="toggle_switch d-flex">
                <input
                  id="is_send_my_participate_notice_to_friends"
                  type="checkbox"
                  className="mr-3"
                  defaultChecked={
                    usersAdditionalInformation.is_send_my_participate_notice_to_friends
                  }
                  value={
                    usersAdditionalInformation.is_send_my_participate_notice_to_friends
                  }
                  onChange={onUpdateIsSendMyParticipateNoticeToFriends}
                  disabled={!usersAdditionalInformation.user.is_vip}
                />
                <label
                  htmlFor="is_send_my_participate_notice_to_friends"
                  className="mb-0 toggle_label"
                ></label>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ns-2026__group">
        <h2 className="ns-2026__group-title">受け取る通知</h2>
        <div className="ns-2026__list">
          <div className="ns-2026__row">
            <div className="ns-2026__row-main">
              <p className="ns-2026__row-title">友だちが参加するイベントを通知</p>
              <div className="toggle_switch d-flex">
                <input
                  id="is_receive_friends_participate_notice"
                  type="checkbox"
                  className="mr-3"
                  defaultChecked={
                    usersAdditionalInformation.is_receive_friends_participate_notice
                  }
                  value={
                    usersAdditionalInformation.is_receive_friends_participate_notice
                  }
                  onChange={onUpdateIsReceiveFriendsParticipateNotice}
                />
                <label
                  htmlFor="is_receive_friends_participate_notice"
                  className="mb-0 toggle_label"
                ></label>
              </div>
            </div>
          </div>

          <div className="ns-2026__row">
            <div className="ns-2026__row-main">
              <p className="ns-2026__row-title">自分が見たイベントの開催情報を通知</p>
              <div className="toggle_switch d-flex">
                <input
                  id="is_receive_watched_events_notice"
                  type="checkbox"
                  className="mr-3"
                  checked={
                    usersAdditionalInformation.is_receive_watched_events_notice
                  }
                  value={
                    usersAdditionalInformation.is_receive_watched_events_notice
                  }
                  onChange={onUpdateIsReceiveWatchedEventsNotice}
                />
                <label
                  htmlFor="is_receive_watched_events_notice"
                  className="mb-0 toggle_label"
                ></label>
              </div>
            </div>
            <p className="ns-2026__row-note">開催の前日と当日にお知らせします</p>
          </div>

          <div className="ns-2026__row">
            <div className="ns-2026__row-main">
              <p className="ns-2026__row-title">トークルームが新しくできたときに通知</p>
              <div className="toggle_switch d-flex">
                <input
                  id="is_receive_new_talkroom_notice"
                  type="checkbox"
                  className="mr-3"
                  checked={
                    usersAdditionalInformation.is_receive_new_talkroom_notice
                  }
                  value={
                    usersAdditionalInformation.is_receive_new_talkroom_notice
                  }
                  onChange={onUpdateIsReceiveNewTalkroomNotice}
                />
                <label
                  htmlFor="is_receive_new_talkroom_notice"
                  className="mb-0 toggle_label"
                ></label>
              </div>
            </div>
            {/* 今近い人向けの通知（SendNearbyPushNotificationsJob）はこの設定を見ないため、
                4つ全体ではなくこの行だけにかかる注意書き */}
            <p className="ns-2026__row-note">
              今近い人検索をONにしている場合は、OFFにしていても通知が届きます
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditNotificationSetting;
